
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"26","viewBox":"0 0 16 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5312 13.9961L4.16403 25.3633C3.89059 25.6367 3.55856 25.7734 3.16794 25.7734C2.77731 25.7734 2.44528 25.6367 2.17184 25.3633L0.882782 24.0742C0.609344 23.8008 0.46286 23.4687 0.443329 23.0781C0.423798 22.6875 0.550751 22.3555 0.824188 22.082L9.90622 13L0.824188 3.91797C0.550751 3.64453 0.423798 3.3125 0.443329 2.92187C0.46286 2.53125 0.609344 2.19921 0.882782 1.92578L2.17184 0.636719C2.44528 0.363281 2.77731 0.226562 3.16794 0.226562C3.55856 0.226562 3.89059 0.363281 4.16403 0.636719L15.5312 12.0039C15.8437 12.2774 16 12.6094 16 13C16 13.3906 15.8437 13.7227 15.5312 13.9961V13.9961Z","fill":"currentColor"}})])
          )
        }
      }
    